import watchListCommon from './common';
import coveredWarrant from './coveredWarrant';
import watchListNews from './news';
import watchListFundamental from './fundamental';
import watchListPerformance from './performance';
import watchListSummary from './summary';
import watchListTechnical from './technical';

export default {
  watchListCommon,
  watchListNews,
  watchListFundamental,
  watchListPerformance,
  watchListSummary,
  watchListTechnical,
  coveredWarrant,
};
